module.exports = __webpack_public_path__ + "static/media/image2.a6f252d2.jpg";